import { useMediaQuery } from '@chakra-ui/react';

/**
 * What "phone" means everywhere: below Chakra's `md` (768px), or a touch
 * phone held in landscape, which is `md` by width but under 32em tall.
 * Without the second clause a rotated phone would get the desktop layout,
 * with fields small enough for iOS to zoom into, and rotating mid-task would
 * swap shells under the user. iPads are taller than 32em and stay desktop.
 *
 * The theme's 16px field net, the toast offset and the App.css phone block
 * use this same string, so they always agree with the layout.
 */
export const PHONE_QUERY =
  '(max-width: 47.99em), (hover: none) and (pointer: coarse) and (max-height: 32em)';

/**
 * True when the phone layout applies. `ssr: false` reads matchMedia on the
 * first render, so the desktop never flashes the phone UI.
 */
export default function useIsPhone() {
  return useMediaQuery(PHONE_QUERY, { ssr: false })[0];
}
